module.exports = __webpack_public_path__ + "img/icon-disposal.dd90039f.svg";